import { render, staticRenderFns } from "./InformativePreviewData.vue?vue&type=template&id=755d2d82&"
import script from "./InformativePreviewData.vue?vue&type=script&lang=js&"
export * from "./InformativePreviewData.vue?vue&type=script&lang=js&"
import style0 from "./InformativePreviewData.vue?vue&type=style&index=0&id=755d2d82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports